import React, {useState} from 'react';
import {useNavigate} from "react-router-dom";
import {useTranslation} from "react-i18next";
import {analysisStats} from "../../components/AnalysisStats";
import {Logs} from "../index";
import dayjs from "dayjs";
import {getFormattedPeriod} from "../../utils";
import './Analysis.css';
import AuditLogsButton from "../../components/Analysis/AuditLogsButton/AuditLogsButton";

const {
    Period,
    TransactionFinancialCard,
    DeviceLastStatusCard,
    DeviceStatusCard,
    NotifyNumberCard,
    TransactionsLineChart,
    DeviceTemperatureCarousel
} = analysisStats;

const Analysis = () => {
    const {t} = useTranslation();
    const [startPeriod, setStartPeriod] = useState(dayjs().format('YYYY-MM-DD'));
    const [endPeriod, setEndPeriod] = useState(dayjs().add(1, 'days').format('YYYY-MM-DD'));
    const navigate = useNavigate();

    const handleNavigate = (targetRoute) => {
        navigate(targetRoute);
    };

    const handleChangePeriod = (value) => {
        const {startPeriod, endPeriod} = getFormattedPeriod(value[0], value[1]);
        setStartPeriod(startPeriod);
        setEndPeriod(endPeriod);
    }

    return (
        <div className='analysis'>
            <div className='analysis__header'>
                <div className="analysis__header-content">
                    <Period handleChangePeriod={handleChangePeriod}/>
                </div>
                <div className="analysis__header-actions">
                    <AuditLogsButton/>
                </div>
            </div>

            <div className="analysis__grid">
                <div className="analysis__main">
                    <div className="analysis__metrics">
                        <div className="analysis__metrics-row">
                            <TransactionFinancialCard startPeriod={startPeriod} endPeriod={endPeriod}/>
                        </div>
                    </div>

                    <div className="analysis__panel analysis__panel--charts">
                        <TransactionsLineChart t={t}/>
                    </div>
                </div>

                <aside className="analysis__side">
                    <div className="analysis__side-panel">
                        <DeviceStatusCard/>
                    </div>
                    <div className="analysis__side-panel">
                        <NotifyNumberCard startPeriod={startPeriod} endPeriod={endPeriod}/>
                    </div>
                    <div className="analysis__side-panel">
                        <DeviceLastStatusCard/>
                    </div>
                </aside>
            </div>

            <DeviceTemperatureCarousel t={t}/>

            <div className='analysis__orders'>
                <div className='analysis__orders-card analysis__panel'>
                    <h2
                        className='analysis__orders-title'
                        onClick={() => handleNavigate("/payments/logs")}
                    >
                        {t("analysis.footerData.title")}
                    </h2>
                    <Logs defaultPaginationSize={20}/>
                </div>
            </div>
        </div>
    );
};

export default Analysis;
